import React from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";

const Hero = () => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO SEEKHO BHARAT"
              title="BEST JOB SEARCH PLATFORM"
            />
            <p>
              Empowering Indian students to pave their path to success – Seekho
              Bharat, your gateway to limitless job opportunities tailored to
              your aspirations
            </p>
            <div className="button">
              <button className="primary-btn">
                GET STARTED NOW <i className="fa fa-long-arrow-alt-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="margin"></div>
    </>
  );
};

export default Hero;
